import React from 'react';
import { UnitFragment } from '../../../generated/graphql';
import { Box } from '@mui/material';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';

export function UnitCoverPhoto(props: { unit: UnitFragment }) {
  const hasCoverPhoto = !!props.unit?.coverPhoto?.urlXs;
  return (
    <Box
      sx={{
        width: 200,
        height: 200,
        overflow: 'hidden',
        marginTop: 2,
        marginBottom: 2,
        backgroundColor: hasCoverPhoto ? undefined : 'lightgray',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {hasCoverPhoto ? (
        <img
          height="200"
          src={props.unit.coverPhoto?.urlXs ?? undefined}
          alt={props.unit.coverPhoto?.desc ?? undefined}
          loading="lazy"
        />
      ) : (
        <NoPhotographyIcon fontSize="large" />
      )}
    </Box>
  );
}
